/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const IMAGE_FIELD_KEYS = {
  image: 'image.image',
} as const;

export const IMAGE_FIELD_KEY_LIST = Object.values(IMAGE_FIELD_KEYS);

export const IMAGE_ACTION_KEYS = {
  reselect: 'image.reselect',
} as const;

export const IMAGE_ACTION_KEY_LIST = Object.values(IMAGE_ACTION_KEYS);

export const IMAGE_OPTION_META_KEYS = {
  image: 'image',
};
